import * as angular from 'angular';
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {ResourcesService} from "../../services/resources-service.service";

export class ResourcesDisplayListComponent implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  public allResources: any[];
  public displayItems: any;

  /* @ngInject */
  constructor(private resourcesService: ResourcesService, private $log: ILogService) {
  }

  $onInit() {
    this.resourcesService.getResources(undefined, undefined, undefined, undefined)
      .then((resources: any[]) => {
        this.allResources = resources;
      })
      .catch((error) => {
        this.$log.error('Failed to get resources', error);
      })
      .finally(() => {
        this.setItems(this.ids);
      })
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      const displayItems = [];
      this.allResources?.forEach(r => {
        if (ids.includes(r.id)) {
          displayItems.push({id: r.id, value: r.name})
        }
      })
      this.displayItems = displayItems;

    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.resources')
  .component('resourcesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./resources-display-list.html').default,
    controller: ResourcesDisplayListComponent
  });
